var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoTopRightCorner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 715.173,
    viewBox: "0 0 400 715.173",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "logo-element-1",
    d: "M189.8,0H.556V156.535l322.772-.322L.556,498.5V715.174h.928L354.994,342l2.451-3.219A209.227,209.227,0,0,0,400.556,210.94C400.556,94.627,306.013,0,189.8,0",
    transform: "translate(-0.557 -0.001)",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTopRightCorner);
export default __webpack_public_path__ + "static/media/logo-top-right-corner.bb23e774727407024857196dd8263410.svg";
export { ForwardRef as ReactComponent };